"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tabs =
/*#__PURE__*/
function () {
  function Tabs(container, params) {
    _classCallCheck(this, Tabs);

    this.container = container;
    this.tabsToggles = _toConsumableArray(container.getElementsByClassName('js-tab-toggle'));
    this.tabsContent = _toConsumableArray(container.getElementsByClassName('js-tab-content'));
    this.contentContainer = _toConsumableArray(container.getElementsByClassName('js-tab-container'))[0];
    this.cursor = container.getElementsByClassName('tab-cursor')[0];
    this.delay = this.tabsContent.length ? parseInt(getComputedStyle(this.tabsContent[0]).transitionDuration.replace('s', '')) * 1000 : 1000;
    this.delay = params.transition ? 0 : this.delay;
    this.activeTab;
    this.activeContent;
    this.nextContent;
    this.init();
  }

  _createClass(Tabs, [{
    key: "init",
    value: function init() {
      this.listen();

      if (this.activeTab) {
        this.activeTab.click();
      } else {
        this.tabsToggles[0].click();
      }
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;

      this.tabsToggles.forEach(function (item) {
        _this.activeTab = item.classList.contains('is-active') ? item : _this.activeTab;
        item.addEventListener('click', function () {
          var target = item.dataset.target;

          var activeContent = _this.container.querySelector("[data-content=".concat(target, "]"));

          if (!activeContent.classList.contains('is-active')) {
            _this.nextContent = activeContent;

            _this.setPositions();

            _this.unsetClasses();

            _this.activeTab = item;
            _this.activeContent = activeContent;

            _this.setClasses();
          }
        });
      });
      window.addEventListener('resize', function () {
        return _this.resize();
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      this.contentContainer.style.height = this.activeContent.offsetHeight + 'px';
    }
  }, {
    key: "unsetClasses",
    value: function unsetClasses() {
      if (this.activeTab) {
        this.activeTab.classList.remove('is-active');
      }

      if (this.activeContent) {
        var activeContent = this.activeContent;
        this.activeContent.classList.remove('is-active');
        setTimeout(function () {
          activeContent.style.display = 'none';
        }, this.delay);
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses() {
      var _this2 = this;

      this.activeTab.classList.add('is-active');
      setTimeout(function () {
        _this2.activeContent.style.display = 'block';
      }, this.delay);
      setTimeout(function () {
        _this2.resize();

        _this2.activeContent.classList.add('is-active');
      }, this.delay + 100);
      this.setUnderline();
    }
  }, {
    key: "setPositions",
    value: function setPositions() {
      var _this3 = this;

      var position = 'prev';
      this.tabsContent.forEach(function (content) {
        if (content == _this3.nextContent) {
          position = 'next';
          return;
        } else {
          content.classList.remove('is-next', 'is-prev');
        }

        content.classList.add('is-' + position);
      });
    }
  }, {
    key: "setUnderline",
    value: function setUnderline() {
      this.cursor.style.width = this.activeTab.offsetWidth + 'px';
      this.cursor.style.left = this.activeTab.offsetLeft + 'px';
    }
  }]);

  return Tabs;
}();

document.addEventListener('DOMContentLoaded', function () {
  var tabs = _toConsumableArray(document.getElementsByClassName('js-tabs'));

  if (tabs.length) {
    tabs.forEach(function (tab) {
      return new Tabs(tab, {
        transition: tab.dataset.transition || null
      });
    });
  }
});